export const DATE_FORMAT = "YYYY-MM-DD";

export const formatStringInQueryString = (str: string) =>
  str
    .split(" ")
    .map((s) => s.toLowerCase())
    .join("_");
